<template>
  <modal transition="overlay-fade"
    :clickToClose="false"
    :delay="100"
    :adaptive="true"
    name="thankYouModal"
    height="auto"
    :scrollable="true"
    :maxWidth="384"
    classes="mt-2 mb-8i"
    width="100%">
    <div class="flex flex-col text-center items-center">
      <div class="h-32 mt-4 overflow-y-hidden">
        <img :src="logo" class="h-40 mr-6">
      </div>
      <span class="block font-bold text-lg mt-8 uppercase text-green-800">{{ title }}</span>
      <span class="block text-sm px-6 mt-4 text-gray-600 max-w-full">
        <span v-html="thankYouMessage"></span>
      </span>
      <div class="flex mb-6">
        <button v-if="button1Title" type="button" class="btn btn-secondary text-sm md:text-base normal-case btn-border btn-selecondary" @click="button1Click">{{ button1Title }}</button>
        <button v-if="button2Title" type="button" class="btn btn-secondary text-sm md:text-base normal-case btn-border btn-selecondary ml-2 md:ml-5" @click="button2OnClick">{{ button2Title }}</button>
      </div>
    </div>
  </modal>
</template>
<script>

  export default {
    data() {
      return {
      }
    },
    computed: {
      logo() {
        return `${this.assets}/img/logo-large.png`
      },
      thankYouMessage() {
        if (this.bodyMessage) {
          return this.bodyMessage
        }
        let message = `Ditt beställnings-ID är ${this.orderId}<br>`
        if (this.pdf) {
          const filename = this.pdf.split('/').reverse()[0];
          return this.print ? 
            `<span class="block mt-1">Din faktura: <a target="_blank" class="underline text-blue-600" href="${this.pdf}">${filename}</a></span><span class="block mt-1">Gåvobeviset kommer till mottagaradressen inom en vecka efter att vi mottagit din betalning.</span>`
            :
            `<span class="block mt-1">Din faktura: <a target="_blank" class="underline text-blue-600" href="${this.pdf}">${filename}</a></span><span class="block mt-1">Gåvobevis och kvitto kommer med e-post när vi mottagit din betalning.</span>`
        }
        return message + (this.print ?
          'Du får ett e-post meddelande med kvitto. Gåvobeviset kommer till mottagaradressen inom en vecka.'
          :
          'Du får ett e-post meddelande med kvitto och gåvobeviset bifogat som pdf-fil.'
          )
      },
    },
    methods: {
      button1Click() {
        if (this.button1OnClick) {
          this.button1OnClick()
        }
        this.$emit('button1Click');
      },
    },
    watch: {
      show: function(newVal, oldVal) {
        if(!oldVal && newVal) {
          this.$modal.show('thankYouModal')
        } else if (oldVal && !newVal) {
          this.$modal.hide('thankYouModal')
        }
      }
    },
    props: {
      print: Boolean,
      bodyMessage: String,
      orderId: Number,
      pdf: String,
      show: Boolean,
      assets: String,
      title: String,
      button1Title: String,
      button1OnClick: Function,
      button2Title: String,
      button2OnClick: Function,
    }
  }
</script>
